import { render, staticRenderFns } from "./PricingTestimonials.vue?vue&type=template&id=39613aea"
import script from "./PricingTestimonials.vue?vue&type=script&lang=js"
export * from "./PricingTestimonials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports